export enum PlatformUrl {
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  IMPRINT = 'IMPRINT',
}
